import Login from './Login.vue'
import ChangeLocation from './ChangeLocation'
import Recover from './Recover'
import ResetPassword from './ResetPassword'

export default [
  {
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    path: '/changeLocation',
    component: ChangeLocation,
    name: 'changeLocation'
  },
  {
    path: '/recover',
    component: Recover,
    name: 'recover'
  },
  {
    path: '/reset/:userId/:token',
    component: ResetPassword,
    name: 'resetPassword'
  }
]
